const ENV = process.env;

Object.keys(ENV).forEach((key) => {
  if (!key.match(/^REACT_APP_/)) return;

  ENV[key.replace(/^REACT_APP_/, "")] = ENV[key];
});

export { ENV };
